import * as THREE from 'three';

/**
 * A small virtual room for an AR lesson on a laptop: a floor, a wall, a table
 * about 1.2 m wide and a doorway about 2.1 m tall -- the two things the
 * measuring lesson asks for, and a table top the skeleton can be stood on.
 *
 * Hidden the moment a real AR session starts; the room is then the real one.
 */
export class DemoRoom {
  readonly group = new THREE.Group();
  /** What a measuring ray or a skeleton looking for the floor can hit. */
  readonly surfaces: THREE.Mesh[] = [];

  constructor() {
    // A small virtual room so the AR flow can be demonstrated on a laptop.
    const material = (colour: string): THREE.MeshStandardMaterial =>
      new THREE.MeshStandardMaterial({ color: colour, roughness: 0.9 });

    const add = (
      geometry: THREE.BufferGeometry,
      mat: THREE.Material,
      x: number,
      y: number,
      z: number,
    ): THREE.Mesh => {
      const mesh = new THREE.Mesh(geometry, mat);
      mesh.position.set(x, y, z);
      this.group.add(mesh);
      this.surfaces.push(mesh);
      return mesh;
    };

    const floor = add(new THREE.PlaneGeometry(8, 8), material('#b9a88f'), 0, 0, 0);
    floor.rotation.x = -Math.PI / 2;
    add(new THREE.PlaneGeometry(8, 3), material('#eef0f2'), 0, 1.5, -2.5);
    // A table about 1.2 m wide, and a doorway about 2.1 m tall: the two things
    // the lesson asks the student to measure.
    add(new THREE.BoxGeometry(1.2, 0.04, 0.7), material('#8d6e4f'), -0.9, 0.75, -1.3);
    for (const [x, z] of [
      [-1.45, -1.6],
      [-0.35, -1.6],
      [-1.45, -1.0],
      [-0.35, -1.0],
    ] as const) {
      add(new THREE.BoxGeometry(0.05, 0.73, 0.05), material('#6b5440'), x, 0.365, z);
    }
    add(new THREE.BoxGeometry(0.9, 2.1, 0.05), material('#c9a27a'), 1.4, 1.05, -2.47);

    const grid = new THREE.GridHelper(8, 16, 0x9a8a72, 0xa8987f);
    grid.position.y = 0.002;
    this.group.add(grid);
  }
}
